import { useEffect, useState } from 'react';

/**
 * Sıra geri sayımı. Sunucu mutlak bir `deadline` gönderiyor, istemci sadece
 * çiziyor — böylece ağ gecikmesi sayacı kaydırmıyor.
 *
 * Koltuklarda halka avatarın çevresine geçer ve kalan saniye avatarın içinde
 * yazar; bu yüzden yazı SVG'nin kendi içinde, tam merkezde duruyor.
 */
/**
 * Bu eşiğin altındaki sayımlarda rakam yazılmaz — yalnızca halka döner.
 * Avatarın baş harfini bu yüzden yalnızca rakam çıkacaksa gizliyoruz.
 */
export const TIMER_TEXT_MIN_MS = 3000;

export function TimerRing({ deadline, total }: { deadline: number | null; total: number }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!deadline) return;
    const id = setInterval(() => setNow(Date.now()), 100);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline || total <= 0) return null;
  const remaining = Math.max(0, deadline - now);
  const ratio = Math.max(0, Math.min(1, remaining / total));
  // Botun düşünme süresi gibi kısa sayımlarda rakam anlamsız ("1", "0"…):
  // yalnızca halka dönüyor, "düşünüyor" göstergesi gibi.
  const showText = total >= TIMER_TEXT_MIN_MS;
  const urgent = showText && remaining <= 5000;
  /**
   * Yarıçap, çizgi kalınlığı çıkarıldığında halkanın dış kenarı viewBox'ın
   * tam kenarına denk gelecek şekilde: 22 (merkez) − 3.5/2 (çizgi) = 20.25.
   * Böylece halka, avatarla aynı kutuda dururken tam onun çevresine oturuyor.
   */
  const radius = 20.25;
  const circumference = 2 * Math.PI * radius;

  return (
    <svg className={urgent ? 'timer timer--urgent' : 'timer'} viewBox="0 0 44 44" aria-hidden>
      <circle className="timer__track" cx="22" cy="22" r={radius} />
      <circle
        className="timer__fill"
        cx="22"
        cy="22"
        r={radius}
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - ratio)}
      />
      {showText && (
        <text className="timer__text" x="22" y="27">
          {Math.ceil(remaining / 1000)}
        </text>
      )}
    </svg>
  );
}
